/*
 * "Uygulamayı Yükle" olayını UYGULAMA AÇILIŞINDA yakalar.
 *
 * NEDEN MODÜL SEVİYESİNDE, BİR BİLEŞENDE DEĞİL:
 * `beforeinstallprompt` sayfa yüklenirken BİR KEZ tetikleniyor. Dinleyici o
 * anda kurulu değilse olay kaybolur ve bir daha gelmez. Düğme ise bildirim
 * menüsünün (AntD `Popover`) içinde ve Popover içeriğini ANCAK AÇILINCA
 * oluşturuyor — yani bileşen mount olduğunda olay çoktan geçmiş oluyor ve
 * düğme hiç çizilmiyordu.
 *
 * Aynı tuzağa service worker kaydında da düşüldü (bkz. `src/index.js`);
 * ikisi de "arayüze bağlı olmayan iş, arayüz bileşenine konulmaz" kuralının
 * örneği.
 *
 * Modül `index.js`'ten import ediliyor, böylece dinleyici React ağacı
 * kurulmadan önce bağlanıyor.
 *
 * Safari bu olayı HİÇ desteklemiyor — iPhone'da düğme çizilmez, orada
 * `BildirimIzniDugmesi` ana ekrana ekleme adımlarını anlatıyor.
 */

let saklananOlay = null;
const aboneler = new Set();

const duyur = () => aboneler.forEach((fn) => fn(!!saklananOlay));

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    // Chrome'un kendi çubuğunu bastırıyoruz; kullanıcı hazır olduğunda
    // düğmeden tetikleyecek.
    e.preventDefault();
    saklananOlay = e;
    duyur();
  });

  window.addEventListener('appinstalled', () => {
    saklananOlay = null;
    duyur();
  });
}

/** Uygulama zaten ana ekrandan mı açılmış? */
export const kuruluMu = () =>
  typeof window !== 'undefined' &&
  (window.matchMedia?.('(display-mode: standalone)').matches ||
    window.navigator.standalone === true);

export const yuklenebilirMi = () => !!saklananOlay;

/** Değişiklikleri dinle; temizleyici döndürür. */
export const yuklenebilirlikAbone = (fn) => {
  aboneler.add(fn);
  return () => aboneler.delete(fn);
};

/**
 * Yükleme penceresini aç.
 *
 * Olay TEK KULLANIMLIK: aynı nesneyle ikinci kez `prompt()` çağrılamıyor.
 * Kullanıcı vazgeçse bile temizliyoruz; Chrome uygun gördüğünde olayı
 * yeniden tetikliyor.
 */
export const yuklemeyiBaslat = async () => {
  if (!saklananOlay) return false;
  try {
    saklananOlay.prompt();
    const secim = await saklananOlay.userChoice;
    return secim?.outcome === 'accepted';
  } catch {
    return false;
  } finally {
    saklananOlay = null;
    duyur();
  }
};
